import { render, staticRenderFns } from "./FolderGridView.vue?vue&type=template&id=72d09824&scoped=true&"
import script from "./FolderGridView.vue?vue&type=script&lang=js&"
export * from "./FolderGridView.vue?vue&type=script&lang=js&"
import style0 from "./FolderGridView.vue?vue&type=style&index=0&id=72d09824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d09824",
  null
  
)

export default component.exports